import type { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={24}
    viewBox='0 0 24 24'
    width={24}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M10.615 2.25a8.365 8.365 0 1 0 5.362 14.787l4.493 4.493a.75.75 0 1 0 1.06-1.06l-4.493-4.493A8.365 8.365 0 0 0 10.615 2.25m4.872 13.203a6.865 6.865 0 1 0-9.743-9.675 6.865 6.865 0 0 0 9.743 9.675'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgSearch;
